import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import privateLibraryActions from 'redux/actions/privateLibraryActions'
import { localize } from 'helpers/translator'


const PrivateLibraryAddPaidLessonsConfirm = props => (<Confirm
	btOne={localize('global_cancel')}
	btTwo={localize('global_confirm')}
	alertTitle={localize('paidLessons_modal_title')}
	alertMessage={localize('paidLessons_modal_text')}
	actionButtonType={0}
	actionOne={() => props.actions.cancel()}
	actionTwo={
		() => {
			props.actions.confirm()
		}
	}
	closeAction={() => props.actions.cancel()} />)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		confirm: privateLibraryActions.findLessons_addLessons_confirm,
		cancel: privateLibraryActions.findLessons_addLessons_cancel,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(PrivateLibraryAddPaidLessonsConfirm)
